import { useGetAllDealerAddressBrandAuthSrcTypeQuery, useCreateDealerAddressBrandAuthSrcTypeMutation, useUpdateDealerAddressBrandAuthSrcTypeMutation, useDeleteDealerAddressBrandAuthSrcTypeMutation } from '../../../../../api';
import { useLanguage } from '../../../../../contexts/LanguageContext';

import { useState } from 'react';

export const useAuthSrcTypeData = ({ dealerAddressBrandId, dealerAddress, pageSize = 10, enabled = true }) => {
    const { th } = useLanguage();

    const [pageNumber, setPageNumber] = useState(1);

    const {
        data = { items: [], count: 0 },
        isLoading,
        isFetching,
        isError,
        error,
        refetch
    } = useGetAllDealerAddressBrandAuthSrcTypeQuery(
        {
            addressBrandId: dealerAddressBrandId,
            pageNumber,
            pageSize
        },
        { skip: !enabled }
    );

    const [createAuthSrcType] = useCreateDealerAddressBrandAuthSrcTypeMutation();
    const [updateAuthSrcType] = useUpdateDealerAddressBrandAuthSrcTypeMutation();
    const [deleteAuthSrcType] = useDeleteDealerAddressBrandAuthSrcTypeMutation();

    const dealerTypeOptions = [
        { label: th('customerAddressBrand.tabs.authSrcType.dialog.options.service'), value: 'SERVICE' },
        { label: th('customerAddressBrand.tabs.authSrcType.dialog.options.salesAndService'), value: 'SALES_AND_SERVICE' },
        { label: th('customerAddressBrand.tabs.authSrcType.dialog.options.sales'), value: 'SALES' },
        { label: th('customerAddressBrand.tabs.authSrcType.dialog.options.sparePartsOrder'), value: 'SPARE_PARTS_ORDER' }
    ];

    const dealerTypeBodyTemplate = (rowData) => {
        const found = dealerTypeOptions.find((option) => option.value === rowData.dealerType);
        return found?.label || rowData.dealerType;
    };

    const columns = [
        { field: 'startDate', header: th('customerAddressBrand.tabs.authSrcType.columns.startDate'), bodyField: 'startDate' },
        { field: 'endDate', header: th('customerAddressBrand.tabs.authSrcType.columns.endDate'), bodyField: 'endDate' },
        {
            field: 'dealerType',
            header: th('customerAddressBrand.tabs.authSrcType.columns.dealerType'),
            body: dealerTypeBodyTemplate
        },
        {
            field: 'termDateAutho',
            header: th('customerAddressBrand.tabs.authSrcType.columns.termDateAutho'),
            body: (row) => (Number(row.termDateAutho) === 1 ? th('customerAddressBrand.tabs.authSrcType.columns.radio.yes') : th('customerAddressBrand.tabs.authSrcType.columns.radio.no'))
        }
    ];

    const save = async (formData) => {
        try {
            if (formData.id) {
                const payload = {
                    id: formData.id,

                    dealerAddressBrandId,
                    startDate: formData.startDate ? new Date(formData.startDate).toISOString() : null,
                    endDate: formData.endDate ? new Date(formData.endDate).toISOString() : null,
                    dealerType: formData.dealerType || '',
                    siteUseId: dealerAddress.id,
                    termDateAutho: Number(formData.termDateAutho) || 0,
                    isActive: 1
                };
                await updateAuthSrcType(payload).unwrap();
                console.log('✅ Yetki Kaydı Güncellendi', payload);
            } else {
                const payload = {
                    dealerAddressBrandId,
                    startDate: formData.startDate ? new Date(formData.startDate).toISOString() : null,
                    endDate: formData.endDate ? new Date(formData.endDate).toISOString() : null,
                    dealerType: formData.dealerType || '',
                    siteUseId: dealerAddress.id,
                    termDateAutho: Number(formData.termDateAutho) || 0
                };
                await createAuthSrcType(payload).unwrap();
                console.log('✅ Yetki Kaydı Oluşturuldu', payload);
            }

            refetch();
        } catch (err) {
            console.error('❌ Yetki Kayıt Hatası:', err);
        }
    };

    const remove = async (id) => {
        try {
            await deleteAuthSrcType({ id, dealerAddressBrandId }).unwrap();
            console.log('✅ Yetki Kaydı Silindi', id);
            refetch();
        } catch (err) {
            console.error('❌ Yetki Silme Hatası:', err);
        }
    };

    return {
        items: data.items,
        count: data.count,
        isLoading: isLoading || isFetching,
        columns,
        save,
        remove,
        refetch,
        pageNumber,
        setPageNumber,
        pageSize
    };
};
